import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnedInIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turned_in"}/>
}
